import { atom } from 'recoil';

export const reportTreeDataAtom = atom({
  key: 'reportTreeDataAtom',
  default: {
    loading: false,
    item: null,
    items: [],
    error: null
  },
});